module.exports = __webpack_public_path__ + "img/hp-h4.b16ad47f.svg";